export default {
  methods: {
    getShortErrorMessage: function(response) {
      if (!response.data.errors.length) {
        return false;
      }

      const error = response.data.errors[0];
      return error.titleShort || error.title;
    },
  }
}